import { useEffect, useState } from "react";
import { styled } from "styled-components";
import { flexColumn, flexColumnBetweenCenter, flexNoneEnd } from "../../styles/mixins.style";
import headerLogo from '../../img/main/header_logo.png'
import mobileLogo from '../../img/main/mobile_logo.png'
import { Link, useLocation } from "react-router-dom";

export default function HomeHeader() {
	const [scrolled, setScrolled] = useState(false);
	const location = useLocation();
	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 10);
		window.addEventListener("scroll", onScroll);
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return (
		<HomeHeaderWrapper $scrolled={scrolled}>
			<HomeNav>
				<MobileLogoLink to="/">
					<img src={mobileLogo} alt="모바일 로고" />
				</MobileLogoLink>
				<HomeNavList>
					<li>
						<NavLink to="/stay" $active={location.pathname === "/stay"}>STAY</NavLink>
					</li>
					<LogoWrap>
						<LogoLink to="/" className="hidden1024">
							<img src={headerLogo} alt="로고" />
						</LogoLink>
						<LogoTextLink to="/" $active={location.pathname === "/"}>HORIGUL</LogoTextLink>
					</LogoWrap>
					<li>
						<NavLink to="/reservation" $active={location.pathname === "/reservation"}>RESERVATION</NavLink>
					</li>
				</HomeNavList>
			</HomeNav>
		</HomeHeaderWrapper>
	);
}

const HomeHeaderWrapper = styled.div<{ $scrolled: boolean }>`
	color: #fff;
	background: ${({ $scrolled }) => ($scrolled ? '#000' : 'transparent')};
	width: 100%;
	height: 7.625rem;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1000;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	font-family: 'Pretendard', sans-serif;
	transition: background 0.3s ease-in-out;
	padding: 0 2rem;

	@media (max-width: 1024px) {
		width: 100vw;
		height: 120px;
		position: fixed;
		top: 0;
		left: 0;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		padding: 0;
	}
	@media (max-width: 768px) {
		height: 4.875rem;
	}
`;

const HomeNav = styled.nav`
	width: 100%;
	${flexColumn}
	align-items: center;

	@media (max-width: 1024px) {
		width: 90%;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		height: 100%;
	}
`;

const MobileLogoLink = styled(Link)`
	display: none;
	@media (max-width: 1024px) {
		display: block;
		margin-right: 2rem;
	}
`;

const HomeNavList = styled.ul`
	padding: 0;
	margin: 0;
	${flexNoneEnd}
	gap: 2.5rem;
	list-style: none;

	@media (max-width: 1024px) {
		flex-direction: row;
		gap: 2rem;
		align-items: center;
	}
	@media (max-width: 768px) {
		gap: 1rem;
	}
`;

const LogoWrap = styled.li`
	${flexColumn}
	align-items: center;
	gap: 0.5rem;
	@media (max-width: 1024px) {
		flex-direction: row;
		align-items: center;
		gap: 0.75rem;
	}
`;

const LogoLink = styled(Link)`
	display: block;
	&.hidden1024 {
		display: block;
	}
`;

const LogoTextLink = styled(Link)<{ $active?: boolean }>`
	font-size: 1rem;
	color: ${({ $active }) => $active ? '#fff' : '#ffffff50'};
	text-decoration: none;
	@media (max-width: 1024px) {
		margin-top: 0;
	}
`;

const NavLink = styled(Link)<{ $active?: boolean }>`
	color: ${({ $active }) => $active ? '#fff' : '#ffffff50'};
	font-weight: ${({ $active }) => $active ? '500' : '400'};
	text-align: center;
	width: 78px;
	display: block;	
	transition: color 0.3s ease;
	font-size: 1rem;
	text-decoration: none;
	margin-top: 0.5rem;
	@media (max-width: 1024px) {
		margin-top: 0;
		width: fit-content;
	}
	@media (max-width: 768px) {
		width: fit-content;
	}
	&:hover {
		color: #fff;
	}
`;